function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 18.75c-4.83 0-8.75-3.93-8.75-8.75S7.17 1.25 12 1.25s8.75 3.93 8.75 8.75-3.92 8.75-8.75 8.75zm0-16C8 2.75 4.75 6 4.75 10S8 17.25 12 17.25 19.25 14 19.25 10 16 2.75 12 2.75zm6 20H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75z"
})));